import React, { useState, useContext } from "react";
import { showToast } from '../../reusables/CommonFunction';
import { ToastContainer } from 'react-toastify';
import { Button, Modal } from "react-bootstrap";
import "./PrescriptionPrint.css";
import AuthContext from '../../../context/AuthContext';
import html2canvas from "html2canvas";
import axiosInstance from '../../../utils/axios';
import PrescriptionForm from "./PrescriptionForm";
import BusyLoaderOverlay from '../../reusables/BusyLoaderOverlay';

const PrescriptionModal = ({ isOpen, onClose, prescriptionDetails, patientEmailAddress }) => {
    let { userDetails } = useContext(AuthContext)
    const [isSending, setIsSending] = useState(false);
    const [loading, setLoading] = useState(false);

    const onHandlePrint = () => {
        const printContent = document.getElementById("a4-content").innerHTML;
        const printWindow = window.open("", "_blank", "height=600,width=800");

        // Extract styles from the document
        let styles = "";
        for (let sheet of document.styleSheets) {
            try {
                for (let rule of sheet.cssRules) {
                    styles += rule.cssText;
                }
            } catch (error) {
                console.warn("Cannot access stylesheet: ", error);
            }
        }

        printWindow.document.write(`
            <html>
            <head>
                <title>Prescription</title>
                <style>${styles}</style>
            </head>
            <body>
                <div id="prescription-print" class="prescription-container">
                    ${printContent}
                </div>
            </body>
            </html>
        `);

        printWindow.document.close();
        printWindow.focus();
        printWindow.print();
        printWindow.close();
    };

    const onHandleSendPdf = async () => {
        if (isSending) return;

        if (patientEmailAddress === undefined || patientEmailAddress.length === 0) {
            showToast("error", "The patient's email address is required to send the PDF.")
            return;
        }

        setIsSending(true);
        setLoading(true);

        const pdfName = `${prescriptionDetails.patient_name}_${prescriptionDetails.visit_date}.pdf`;

        // Dynamically import jsPDF
        const { jsPDF } = await import("jspdf");

        // Get the content
        const content = document.getElementById("a4-content");
        if (!content) {
            console.error("Element with ID 'a4-content' not found.");
            return;
        }

        document.getElementById("clinic_name").style.lineBreak = "anywhere";
        content.classList.add("print-mode");

        // Use html2canvas on the cloned node
        const canvas = await html2canvas(content, {
            scale: 2,
            useCORS: true,
            scrollY: 0,
            letterRendering: true,
        });

        content.classList.remove("print-mode");
        const imgData = canvas.toDataURL("image/png");

        // Create a jsPDF document (A4 size)
        const doc = new jsPDF({
            orientation: "portrait",
            unit: "mm",
            format: "a4",
        });

        // Add the image to PDF
        doc.addImage(imgData, "PNG", 0, 0, 210, 297);

        // Convert PDF to Blob
        const pdfBlob = doc.output("blob");

        // Create FormData to send file to Django
        const formData = new FormData();
        formData.append("pdf_file", pdfBlob, pdfName);
        formData.append("patient_name", prescriptionDetails.patient_name);
        formData.append("patient_email", patientEmailAddress);
        formData.append("doctor_registration_number", prescriptionDetails.registration_number);

        try {
            const response = await axiosInstance.post("patients/prescription_form/", formData, {
                timeout: 10000,
                headers: {
                    "Content-Type": "multipart/form-data",
                }
            });
            showToast("success", response.data.message);
        } catch (error) {
            console.error("Error sending PDF:", error);
        } finally {
            setIsSending(false);
            setLoading(false);
        }
    };

    return (
        <>
            <Modal show={isOpen} onHide={onClose} size="xl" backdrop="static" keyboard={false} centered>
                <Modal.Header closeButton>
                    <Modal.Title>Prescription</Modal.Title>
                </Modal.Header>
                <Modal.Body className="p-4 overflow-auto a4-modal-body">
                    <PrescriptionForm prescriptionDetails={prescriptionDetails} />
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="primary" disabled={prescriptionDetails.user_type === "M"} onClick={onHandlePrint}>Print</Button>
                    <Button variant="secondary" disabled={prescriptionDetails.user_type === "M" || userDetails.is_clinic_plan_expired === true} hidden={userDetails.plan_type === "F"} onClick={onHandleSendPdf}>{isSending ? 'Sending PDF...' : 'Send PDF'}</Button>
                    <Button variant="secondary" onClick={onClose}>Close</Button>
                </Modal.Footer>
                <ToastContainer />
                <BusyLoaderOverlay show={loading} />
            </Modal>
        </>
    );
};

export default PrescriptionModal;
